export const SET_SELECTED_ARTICULOS_REPOSICION = 'SET_SELECTED_ARTICULOS_REPOSICION';
export const SET_PAGINATION_REPOSICION = 'SET_PAGINATION_REPOSICION';
export const SET_UNIDADES_ARTICULO_REPOSICION = 'SET_UNIDADES_ARTICULO_REPOSICION';

export const INICIAR_MODULO_REPOSICIONES_NEWCO = 'INICIAR_MODULO_REPOSICIONES_NEWCO';
export const INICIAR_MODULO_REPOSICIONES_NEWCO_END = 'INICIAR_MODULO_REPOSICIONES_NEWCO_END';

export const GET_ARTICULOS_REPOSICIONES = 'GET_ARTICULOS_REPOSICIONES';
export const GET_ARTICULOS_REPOSICIONES_REQUEST = 'GET_ARTICULOS_REPOSICIONES_REQUEST';
export const GET_ARTICULOS_REPOSICIONES_SUCCESS = 'GET_ARTICULOS_REPOSICIONES_SUCCESS';
export const GET_ARTICULOS_REPOSICIONES_FAILURE = 'GET_ARTICULOS_REPOSICIONES_FAILURE';

export const COMPROBAR_ARTICULOS_REPOSICIONES_STOCK = 'COMPROBAR_ARTICULOS_REPOSICIONES_STOCK';
export const GET_ARTICULOS_REPOSICIONES_STOCK_REQUEST = 'GET_ARTICULOS_REPOSICIONES_STOCK_REQUEST';
export const GET_ARTICULOS_REPOSICIONES_STOCK_SUCCESS = 'GET_ARTICULOS_REPOSICIONES_STOCK_SUCCESS';
export const GET_ARTICULOS_REPOSICIONES_STOCK_FAILURE = 'GET_ARTICULOS_REPOSICIONES_STOCK_FAILURE';

export const OBTENER_PROVEEDORES_REPOSICIONES_STOCK = 'OBTENER_PROVEEDORES_REPOSICIONES_STOCK';
export const GET_PROVEEDORES_REPOSICIONES_REQUEST = 'GET_PROVEEDORES_REPOSICIONES_REQUEST';
export const GET_PROVEEDORES_REPOSICIONES_SUCCESS = 'GET_PROVEEDORES_REPOSICIONES_SUCCESS';
export const GET_PROVEEDORES_REPOSICIONES_FAILURE = 'GET_PROVEEDORES_REPOSICIONES_FAILURE';

export const GENERAR_PEDIDO_GW1 = 'GENERAR_PEDIDO_GW1';
export const SET_DEFAULT_FILTERS = 'SET_DEFAULT_FILTERS';
export const SET_FILTER = 'SET_FILTER';
export const RESETEAR_SELECCION = 'RESETEAR_SELECCION';

export const SELECCIONAR_TIPO_ARTICULO = 'SELECCIONAR_TIPO_ARTICULO';
export const GET_VALORES_PROPIEDADES_ARTICULOS_REQUEST = 'GET_VALORES_PROPIEDADES_ARTICULOS_REQUEST';
export const GET_VALORES_PROPIEDADES_ARTICULOS_SUCCESS = 'GET_VALORES_PROPIEDADES_ARTICULOS_SUCCESS';
export const GET_VALORES_PROPIEDADES_ARTICULOS_FAILURE = 'GET_VALORES_PROPIEDADES_ARTICULOS_FAILURE';

export const GENERAR_CSV_ARTICULOS_REPOSICIONES = 'GENERAR_CSV_ARTICULOS_REPOSICIONES';
export const GET_CSV_ARTICULOS_REPOSICIONES_REQUEST = 'GET_CSV_ARTICULOS_REPOSICIONES_REQUEST';
export const GET_CSV_ARTICULOS_REPOSICIONES_SUCCESS = 'GET_CSV_ARTICULOS_REPOSICIONES_SUCCESS';
export const GET_CSV_ARTICULOS_REPOSICIONES_FAILURE = 'GET_CSV_ARTICULOS_REPOSICIONES_FAILURE';

export const REPOSICIONES_SET_SEARCH_TEXT = 'REPOSICIONES_SET_SEARCH_TEXT';
export const REPOSICIONES_SET_RANGO_FECHAS = 'REPOSICIONES_SET_RANGO_FECHAS';
